/* Svensk katalog for locale-no.js (del 4 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Möjlig minskning av kredittiden',
  'adv.sales.move.chaseSlowPayers.effectNote': 'ned mot ditt eget snitt — kronoeffekten beror på när kunden faktiskt betalar',
  'adv.sales.move.chaseSlowPayers.action': 'Visa fakturalistan',
  'adv.sales.move.reviewDiscounts.title': 'Gå igenom rabatterna',
  'adv.sales.move.reviewDiscounts.text': 'Du har gett {amount} i rabatt i år, i snitt {pct} % per faktura.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Uppskattad effekt',
  'adv.sales.move.reviewDiscounts.effectNote': 'genom att halvera rabattnivån',
  'adv.sales.move.reviewDiscounts.action': 'Visa fakturalistan',
  'adv.sales.move.spreadCustomers.title': 'Bredda kundbasen',
  'adv.sales.move.spreadCustomers.text': '{name} står för {pct} % av försäljningen. En enda kund bör inte bära omsättningen ensam.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Andel från största kund',
  'adv.sales.move.spreadCustomers.effectNote': 'detta är risken, inte en vinst',
  'adv.sales.move.spreadCustomers.action': 'Visa kunder',
  'adv.sales.move.testPriceIncrease.title': 'Överväg en prishöjning',
  'adv.sales.move.testPriceIncrease.text': 'Testa vad {pct} % högre pris gör med omsättningen innan du bestämmer dig.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Uppskattad årlig effekt',
  'adv.sales.move.testPriceIncrease.effectNote': 'med dagens volym',
  'adv.sales.move.testPriceIncrease.action': 'Visa produkter',
  'adv.sales.move.growRecurring.title': 'Bygg mer återkommande försäljning',
  'adv.sales.move.growRecurring.text': '{pct} % av försäljningen är återkommande. Når du upp mot {target} % blir omsättningen betydligt mer förutsägbar.',
  'adv.sales.move.growRecurring.effectLbl': 'Omsättning som kan bli förutsägbar',
  'adv.sales.move.growRecurring.effectNote': 'om andelen når målet',
  'adv.sales.move.growRecurring.action': 'Visa abonnemang',
  'adv.sales.scn.title': 'Försäljningsscenarier — Vad händer om …',
  'adv.sales.scn.sub': 'Effekt på omsättning, resultat och likviditet',
  'adv.sales.scn.help': 'Välj ett scenario för att se före/efter för omsättning, resultat, marginal och likviditet, tillsammans med de antaganden jag har utgått från. Siffrorna är beräkningar, inte garantier.',
  'adv.sales.scn.metric': 'Nyckeltal',
  'adv.sales.scn.base': 'Bas',
  'adv.sales.scn.after': 'Efter scenario',
  'adv.sales.scn.change': 'Förändring',
  'adv.sales.scn.row.revenue': 'Omsättning',
  'adv.sales.scn.row.result': 'Resultat',
  'adv.sales.scn.row.margin': 'Resultatmarginal',
  'adv.sales.scn.row.liquidity': 'Beräknat plansaldo',
  'adv.sales.scn.points': '{points} p.e.',
  'adv.sales.scn.assumptions': 'Antaganden',
  'adv.sales.scn.showAssumptions': 'Visa antaganden',
  'adv.sales.scn.confidence': 'Säkerhet',
  'adv.sales.scn.risk': 'Risk',
  'adv.sales.scn.scope': 'Omfattning',
  'adv.sales.scn.q.priceUp': 'Jag höjer priserna',
  'adv.sales.scn.q.volumeDown': 'Försäljningsvolymen minskar',
  'adv.sales.scn.q.halveDiscounts': 'Jag tar bort hälften av rabatterna',
  'adv.sales.scn.q.loseTopCustomer': 'Jag förlorar {name}',
  'adv.sales.scn.q.growRecurring': 'Återkommande försäljning ökar {pct} %',
  'adv.sales.scn.summary.priceUp': 'Med dagens volym ger {pct} % prishöjning ungefär {delta} mer i årlig omsättning. En prishöjning ger ingen extra varu- eller timkostnad, så hela beloppet slår igenom på resultatet.',
  'adv.sales.scn.summary.volumeDown': 'En volymminskning på {pct} % tar ungefär {delta} från omsättningen. Beräkningen förutsätter att kostnaderna står still, så detta är det strängaste utfallet — minskar varuinköpen med volymen blir effekten mindre.',
  'adv.sales.scn.summary.halveDiscounts': 'Du har gett {amount} i rabatt i år, i snitt {pct} %. Halverar du nivån tar du in ungefär {delta} — förutsatt att kunderna stannar.',
  'adv.sales.scn.summary.loseTopCustomer': 'Försvinner {name} förlorar du {delta} — {pct} % av försäljningen. Det är siffran som gör kundspridning värd att ta tag i innan det händer.',
  'adv.sales.scn.summary.growRecurring': 'Ökar den återkommande försäljningen {pct} % ger det ungefär {delta} mer per år. Återkommande intäkter är den mest förutsägbara omsättning du har.',
  'adv.sales.scn.assumption.priceUp': 'Volymen håller i sig. Gäller alla produkter och tjänster.',
  'adv.sales.scn.assumption.volumeDown': 'Kostnaderna står still. Plumme har inget inköpspris per produkt, så jag kan inte räkna ut hur mycket av kostnaden som minskar med volymen.',
  'adv.sales.scn.assumption.halveDiscounts': 'Kunderna köper lika mycket med lägre rabatt. Beräknat utifrån faktiskt given rabatt i år.',
  'adv.sales.scn.assumption.loseTopCustomer': 'Ingen del av omsättningen ersätts av andra kunder. Beräknat utifrån kundens faktiska bokförda försäljning.',
  'adv.sales.scn.assumption.growRecurring': 'Tillväxten kommer utöver dagens försäljning, inte i stället för den.',
  'adv.sales.scn.riskText.priceUp': 'Om volymen faller mer än prishöjningen försvinner effekten. Följ försäljningsvolymen de första två månaderna.',
  'adv.sales.scn.riskText.volumeDown': 'Om volymen faller hos de mest lönsamma kunderna först blir effekten större än så här.',
  'adv.sales.scn.riskText.halveDiscounts': 'Kunder som köper på grund av rabatten kan falla bort. Testa på några få först.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Fasta kostnader försvinner inte med kunden, så resultatet drabbas hårdare än omsättningen.',
  'adv.sales.scn.riskText.growRecurring': 'Återkommande avtal binder dig till pris och leverans över tid.',
  'adv.sales.scn.scopeText.all': 'Alla produkter och tjänster',
  'adv.sales.scn.scopeText.discounted': 'Bara fakturor med rabatt',
  'adv.sales.scn.scopeText.topCustomer': 'Bara största kunden',
  'adv.sales.scn.scopeText.recurring': 'Bara återkommande försäljning',
  'adv.sales.closerTag': 'Det här skulle jag ha gjort',
  'adv.tab.tax': 'Skatt',
  'adv.tab.budget': 'Budget',
  'adv.tab.insight': 'Insikt',
  'adv.plan.title': 'Budget mot utfall',
  'adv.plan.sub': '{year} — bokfört hittills mot budgeten för de första {months} månaderna',
  'adv.plan.help': 'Bokförda siffror gäller hittills i år, medan budgeten gäller hela året. Jag jämför därför med budgeten till och med innevarande månad — annars skulle allt se ut att ligga långt under budget i januari.',
  'adv.plan.tableTitle': 'Avvikelse per kategori',
  'adv.plan.tableSub': 'Budget för de första {months} månaderna mot bokfört',
  'adv.plan.tableHelp': 'Raderna är sorterade efter avvikelsens storlek. Konton som det har bokförts på utan att de har budgeterats visas också — de är ofta de mest intressanta.',
  'adv.plan.col.category': 'Kategori',
  'adv.plan.col.budget': 'Budget hittills',
  'adv.plan.col.actual': 'Bokfört',
  'adv.plan.col.variance': 'Avvikelse',
  'adv.plan.unbudgeted': 'Ej budgeterat',
  'adv.plan.incomeVariance': 'Intäktsavvikelse',
  'adv.plan.costVariance': 'Kostnadsavvikelse',
  'adv.plan.abovePlan': 'över plan',
  'adv.plan.belowPlan': 'under plan',
  'adv.plan.overPlan': 'över plan',
  'adv.plan.underPlan': 'under plan',
  'adv.plan.separateNote': 'Intäkts- och kostnadsavvikelsen visas var för sig. Om de slås ihop kan ett intäktstapp och en kostnadsbesparing ta ut varandra och se ut som att allt går enligt plan.',
  'adv.plan.noteWorse': '{name} avviker {amount} i fel riktning efter {months} månader. Värt att titta på innan avvikelsen växer under resten av året.',
  'adv.plan.noteBetter': '{name} ligger {amount} bättre till än budgeterat efter {months} månader.',
  'adv.plan.noteUnbudgeted': 'Det har bokförts {amount} på {name} utan att kontot har budgeterats.',
  'adv.plan.editBudget': 'Ändra budgeten',
  'adv.plan.noBudgetTitle': 'Ingen budget för det här året',
  'adv.plan.noBudgetText': 'Utan en budget har jag ingenting att mäta de bokförda siffrorna mot. Om du lägger in en visar jag avvikelser per kategori och säger till när något drar iväg från planen.',
  'adv.plan.goToBudget': 'Skapa budget',
  'adv.plan.notStartedTitle': 'Året har inte börjat ännu',
  'adv.plan.notStartedText': 'Det finns inga bokförda månader i {year} att jämföra budgeten mot.',
  'adv.plan.goalsTitle': 'Mål',
  'adv.plan.goalsSub': 'Dina egna mål, mätta mot bokförda siffror',
  'adv.plan.goalsHelp': 'Målet visas från det år du skapar det för och framåt tills du markerar det som slutfört. Ett mål vars deadline har passerat står kvar tills du bedömer det på nytt. Intäkter, resultat och marginal mäts per räkenskapsår, medan buffert följer saldot.',
  'adv.plan.goalsEmptyTitle': 'Inga mål satta ännu',
  'adv.plan.goalsEmptyText': 'Sätt ett mål med en deadline — till exempel en kassabuffert eller en resultatmarginal — så följer jag framstegen och säger till om du halkar efter.',
  'adv.plan.goalNew': 'Nytt mål',
  'adv.plan.goalEdit': 'Ändra mål',
  'adv.plan.goalSave': 'Spara mål',
  'adv.plan.goalSaved': 'Målet har sparats',
  'adv.plan.goalSaveFailed': 'Det gick inte att spara målet',
  'adv.plan.goalDeleted': 'Målet har tagits bort',
  'adv.plan.goalTitleLabel': 'Vad är målet?',
  'adv.plan.goalTitlePh': 'T.ex. Bygg upp en kassabuffert före nyår',
  'adv.plan.goalMetricLabel': 'Vad ska mätas?',
  'adv.plan.goalMetricHint': 'Det aktuella värdet hämtas från bokföringen, inte från något du skriver in.',
  'adv.plan.goalTargetAmount': 'Målvärde (kr)',
  'adv.plan.goalTargetPct': 'Målvärde (%)',
  'adv.plan.goalNow': 'Nu',
  'adv.plan.goalTarget': 'Mål',
  'adv.plan.goalDeadline': 'Deadline',
  'adv.plan.goalDaysLeft': 'Dagar kvar',
  'adv.plan.goalMeasured': 'Mäts mot: {metric}',
  'adv.plan.goalFromYear': 'Från {year}',
  'adv.plan.goalReached': 'Uppnått',
  'adv.plan.goalCompleted': 'Slutfört',
  'adv.plan.goalNeedsReview': 'Deadline passerad – bedöm målet',
  'adv.plan.goalComplete': 'Markera målet som slutfört',
  'adv.plan.goalReopen': 'Återöppna mål',
  'adv.plan.goalOverdue': 'Deadline har passerat',
  'adv.plan.goalOnTrack': 'Enligt plan',
  'adv.plan.goalBehind': 'Efter plan',
  'adv.plan.goalTracking': 'Följer upp',
  'adv.plan.metric.buffer': 'Kassabehållning vid årets slut',
  'adv.plan.metric.income': 'Bokförd omsättning',
  'adv.plan.metric.result': 'Bokfört resultat',
  'adv.plan.metric.margin': 'Resultatmarginal',
  'adv.plan.saving': 'Sparar …',
  'adv.plan.eventsTitle': 'Planerade händelser',
  'adv.plan.eventsSub': 'Kända in- och utbetalningar som ännu inte är bokförda',
  'adv.plan.eventsHelp': 'Händelser visas under det år datumet hör till. De flyttas inte automatiskt till nästa år; ändra datumet om betalningen har skjutits upp. Endast kommande, obokförda händelser läggs in i kassaflödesprognosen.',
  'adv.plan.eventsEmptyTitle': 'Inga planerade händelser',
  'adv.plan.eventsEmptyText': 'Utan registrerade händelser ligger kassaflödeskurvan platt efter innevarande månad, eftersom den bara känner till bokförda siffror.',
  'adv.plan.eventsNote': 'Händelser i tidigare månader tas inte med i kurvan. Ta bort en händelse när betalningen är bokförd, så att den inte räknas två gånger.',
  'adv.plan.eventNew': 'Ny händelse',
  'adv.plan.eventEdit': 'Ändra händelse',
  'adv.plan.eventSave': 'Spara händelse',
  'adv.plan.eventSaved': 'Händelsen har sparats',
  'adv.plan.eventSaveFailed': 'Det gick inte att spara händelsen',
  'adv.plan.eventDeleted': 'Händelsen har tagits bort',
  'adv.plan.eventLabel': 'Vad gäller det?',
  'adv.plan.eventLabelPh': 'T.ex. Semesterersättning till anställda',
  'adv.plan.eventKind': 'Typ',
  'adv.plan.eventDate': 'Datum',
  'adv.plan.eventDirection': 'Riktning',
  'adv.plan.eventDirectionHint': 'Ut sänker kassabehållningen, in ökar den.',
  'adv.plan.directionOut': 'Ut från kontot',
  'adv.plan.directionIn': 'In på kontot',
  'adv.plan.eventAmount': 'Belopp',
  'adv.plan.kind.salary': 'Lön och bonus',
  'adv.plan.kind.tax': 'Skatter och avgifter',
  'adv.plan.kind.supplier': 'Leverantörsbetalning',
  'adv.plan.kind.investment': 'Investering',
  'adv.plan.kind.loan': 'Lån och amorteringar',
  'adv.plan.kind.other': 'Övrigt',
  'adv.tab.reports': 'Rapporter',
  'adv.tab.benchmark': 'Jämförelse',
  'adv.basisCmp.title': 'Jämförelseunderlag',
  'adv.basisCmp.sub': 'Vad siffrorna faktiskt mäts mot',
  'adv.basisCmp.help': 'Nyckeltalen nedan jämförs inte med andra företag. Två av dem mäts mot företagets egna siffror från året innan och två mot en fast tröskel. Varje rad är märkt med vilket av dem det är.',
  'adv.basisCmp.year': 'Räkenskapsår',
  'adv.basisCmp.against': 'Jämfört med',
  'adv.basisCmp.againstValue': 'Egna siffror från {year}',
  'adv.basisCmp.source': 'Datakälla',
  'adv.basisCmp.sourceValue': 'Bokförda siffror i Plumme',
  'adv.basisCmp.industry': 'Branschdata',
  'adv.basisCmp.industryValue': 'Inte tillgängligt',
  'adv.basisCmp.row.previousYear': 'mot {year}',
  'adv.basisCmp.row.threshold': 'mot fast tröskel',
  'adv.hero.tag': 'SuperPlummas insikt den här månaden',
  'adv.hero.empty': 'AI Rådgivare behöver bokförda intäkter, kostnader och öppna poster innan den kan ge konkreta råd.',
  'adv.hero.freeCapital': 'Ledigt kapital',
  'adv.hero.notCalculated': 'inte beräknat',
  'adv.hero.healthScore': 'Hälsopoäng',
  'adv.hero.waiting': 'väntar',
  'adv.hero.ask': 'Fråga SuperPlumma',
  'adv.hero.chatTitle': 'Chatta med SuperPlumma',
  'adv.hero.chatHint': 'Chatta med mig',
  'adv.hero.briefTag': 'Månadsinsikt från SuperPlumma · {year}',
  'adv.hero.healthLead': 'Ekonomisk hälsa:',
  'adv.hero.greeting.morning': 'God morgon.',
  'adv.hero.greeting.day': 'Hej.',
  'adv.hero.greeting.evening': 'God kväll.',
  'adv.hero.greetingNamed.morning': 'God morgon, {name}.',
  'adv.hero.greetingNamed.day': 'Hej, {name}.',
  'adv.hero.greetingNamed.evening': 'God kväll, {name}.',
  'adv.hero.tasksToday': '{count} saker att göra i dag',
  'adv.hero.seeAnalysis': 'Se analys',
  'adv.hero.effectNote.earlierIn': 'tidigare in',
  'adv.hero.effectNote.overduePayables': 'förfallet till leverantör',
  'adv.hero.effectNote.vatToCover': 'måste täckas',
  'adv.hero.effectNote.vouchersAtRisk': 'köp utan verifikation',
  'adv.overnight.title': 'SuperPlumma har gått igenom',
  'adv.overnight.transactions': '{count} transaktioner analyserade',
  'adv.overnight.vouchers': '{count} verifikationer kontrollerade',
  'adv.overnight.risks': '{count} risker bedömda',
  'adv.overnight.recommendations': '{count} rekommendationer hittade',
  'adv.overnight.updated': 'Senast uppdaterad {time}',
  'adv.analysis.title': 'Öppen AI-analys av bokföringen',
  'adv.analysis.empty': 'Analysen är inte tillgänglig just nu.',
  'adv.feed.title': 'SuperPlumma höll koll',
  'adv.feed.sub': 'Det jag har lagt märke till på sistone',
  'adv.feed.help': 'Förändringar jag har upptäckt i bokföringen — inte rekommendationer. Rött är brådskande, gult bör följas upp, grönt är bara information.',
  'adv.feed.seeDetails': 'Se detaljer',
  'adv.feed.marginDown.title': 'Rörelsemarginalen har sjunkit {points} procentenheter',
  'adv.feed.marginDown.body': 'Jämfört med förra året. Värt att titta närmare på innan det blir en trend.',
  'adv.feed.marginUp.title': 'Rörelsemarginalen har stigit {points} procentenheter',
  'adv.feed.marginUp.body': 'Jämfört med förra året. Inga åtgärder behövs — bara trevligt att veta.',
  'adv.feed.costLineJump.title': '{name} har ökat {pct} %',
  'adv.feed.costLineJump.body': 'Kostnadsposten växer snabbare än resten jämfört med förra året.',
  'adv.feed.overdueSales.title': '{amount} i kundfordringar har förfallit',
  'adv.feed.overdueSales.body': 'Pengarna är redan intjänade — de har bara inte kommit in ännu.',
  'adv.feed.overduePurchases.title': '{amount} i leverantörsskulder har förfallit',
  'adv.feed.overduePurchases.body': 'Förfallna leverantörsskulder kan ge dröjsmålsränta och påminnelseavgift.',
  'adv.feed.concentration.title': 'En kund står för {pct} % av försäljningen',
  'adv.feed.concentration.body': 'Högt kundberoende gör omsättningen sårbar om kunden försvinner.',
  'adv.feed.costsDown.title': 'Kostnaderna har minskat {pct} % jämfört med förra året',
  'adv.feed.costsDown.body': 'Inga åtgärder behövs — bara trevligt att veta.',
  'adv.feed.incomeUp.title': 'Omsättningen har ökat {pct} % jämfört med förra året',
  'adv.feed.incomeUp.body': 'Tillväxten är beräknad utifrån bokförda intäkter under samma period.',
  'adv.feed.vouchersComplete.title': 'Alla köp har verifikation',
  'adv.feed.vouchersComplete.body': 'Ingenting här kräver din uppmärksamhet just nu.',
  'adv.employees.title': 'Anställda & lön',
  'adv.employees.help': 'Modulen visas bara eftersom företaget har anställda eller lönekörningar. Siffrorna är hämtade från bokförda lönekostnader och dina lönekörningar.',
  'adv.employees.count': 'Anställda',
  'adv.employees.share': 'Lönekostnad / omsättning',
  'adv.employees.cost': 'Bokförd lönekostnad',
  'adv.employees.runs': 'Lönekörningar i år',
  'adv.employees.note': 'Löneandelen är beräknad utifrån bokförda konton i 5000-serien mot årets omsättning.',
  'adv.employees.go': 'Se lön',
  'adv.taskcenter.title': 'Mina uppgifter från SuperPlumma',
  'adv.taskcenter.all': 'Alla',
  'adv.taskcenter.empty': 'Inga uppgifter i den här kategorin.',
  'adv.status.bucket.now': 'Kräver åtgärd nu',
  'adv.profile.title': 'Rådgivarprofil',
  'adv.profile.help': 'Allt SuperPlumma vet om hur du vill ha råd — buffert, mål, risknivå och frekvens — samlat på ett ställe. Du kan ändra allt här.',
  'adv.profile.intro': 'Det här använder jag för att göra råden mer träffsäkra. Ändrar du något här ändrar det hur jag prioriterar — inte hur bokföringen sköts.',
  'adv.profile.buffer': 'Önskad buffert',
  'adv.profile.mainGoal': 'Viktigaste mål',
  'adv.profile.mainGoal.revenue': 'Öka omsättningen',
  'adv.profile.mainGoal.profitability': 'Öka lönsamheten',
  'adv.profile.mainGoal.buffer': 'Bygga kassabuffert',
  'adv.profile.mainGoal.hiring': 'Anställa',
  'adv.profile.mainGoal.investment': 'Investera',
  'adv.profile.mainGoal.workload': 'Minska arbetsbelastningen',
  'adv.profile.mainGoal.dividend': 'Göra företaget redo för utdelning',
  'adv.profile.risk': 'Föredragen risknivå',
  'adv.profile.risk.cautious': 'Trygg och försiktig',
  'adv.profile.risk.balanced': 'Balanserad',
  'adv.profile.risk.offensive': 'Öppen för risk',
  'adv.profile.cadence': 'Hur ofta du vill ha råd',
  'adv.profile.cadence.daily': 'Dagligen',
  'adv.profile.cadence.weekly': 'Varje vecka',
  'adv.profile.cadence.monthly': 'Varje månad',
  'adv.profile.accountantInvolved': 'Redovisningskonsulten ska involveras i förslag som kräver bedömning',
  'adv.profile.investments': 'Planerade händelser',
  'adv.profile.noInvestments': 'Inga registrerade',
  'adv.profile.season': 'Säsongsmönster',
  'adv.profile.seasonText': 'Starka månader: {strong}. Svaga månader: {weak}.',
  'adv.profile.noSeason': 'För lite bokfört för att se ett mönster ännu.',
  'adv.profile.learned': 'Vad jag har lärt mig av dina val',
  'adv.profile.nothingLearned': 'Ingenting inlärt ännu.',
  'adv.profile.saveFailed': 'Kunde inte spara rådgivarprofilen',
  'adv.buffer.recommended': 'Rekommenderad buffert',
  'adv.buffer.chosen': 'Vald buffert',
  'adv.buffer.edit': 'Justera likviditetsbuffert',
  'adv.buffer.editAria': 'Justera likviditetsbuffert på {amount}',
  'adv.buffer.title': 'Likviditetsbuffert',
  'adv.buffer.auto': 'Automatisk rekommendation',
  'adv.buffer.autoHelp': 'SuperPlumma använder det högsta beräknade behovet. Just nu är rekommendationen {amount}.',
  'adv.buffer.custom': 'Eget belopp',
  'adv.buffer.customHelp': 'Använd det här beloppet som fast gräns i råd, risk och kassaflöde.',
  'adv.buffer.amount': 'Önskad buffert i kronor',
  'adv.buffer.basisTitle': 'Underlag för automatisk rekommendation',
  'adv.buffer.basisMinimum': 'Miniminivå',
  'adv.buffer.basisMonthlyCosts': 'En månads kostnader',
  'adv.buffer.basisTax': 'Beräknad skattereserv',
  'adv.buffer.basisVat': 'Kommande moms',
  'adv.buffer.basisHelp': 'Automatisk buffert använder det högsta av dessa belopp. Detta är en styrgräns, inte pengar som står på ett eget konto.',
  'adv.buffer.saving': 'Sparar …',
  'adv.buffer.saved': 'Likviditetsbuffert sparad',
  'adv.buffer.invalid': 'Ange ett belopp större än 0 kr.',
  'adv.buffer.unavailable': 'Buffertinställningen är inte tillgänglig just nu.',
  'adv.buffer.saveFailed': 'Kunde inte spara likviditetsbufferten.',
  'adv.generated.kicker': 'Öppen AI-analys av bokföringen',
  'adv.generated.daily': 'Dagens råd',
  'adv.generated.monthly': 'Den här månaden',
  'adv.generated.previousMonthly': 'Förra månaden',
  'adv.generated.loading': 'SuperPlumma läser det uppdaterade rådgivningsunderlaget …',
  'adv.generated.updated': 'Uppdaterad {date}',
  'adv.generated.topOpportunity': 'Din största möjlighet',
  'adv.generated.changes': 'Vad händer just nu?',
  'adv.generated.actions': 'Det här skulle jag göra nu',
  'adv.generated.opportunities': 'Möjligheter',
  'adv.generated.taxChecks': 'Skatt och moms – kontrollpunkter',
  'adv.generated.more': 'Se fler möjligheter och kontrollpunkter',
  'adv.generated.nextStep': 'Nästa steg',
  'adv.generated.readOnly': 'Analysen är endast rådgivande och utför inga åtgärder.',
  'adv.generated.importCoverage': 'Baserat på importerade summor och reskontra. Kontroll av enskilda bokföringar och verifikationernas fullständighet är begränsad.',
  'adv.generated.refresh': 'Uppdatera råd',
  'adv.generated.failed': 'Kunde inte uppdatera AI-rådet nu.',
  'adv.generated.unavailable': 'Inga AI-råd är klara ännu',
  'adv.generated.empty': 'Det finns inga färdiga råd att visa ännu. Försök att uppdatera råden.',
  'adv.generated.limitReached': 'Månadsgränsen för nya AI-råd är nådd. Befintliga råd är fortfarande tillgängliga, och gränsen återställs nästa månad.',
  'adv.generated.todayCurrent': 'Dagens råd är klart',
  'adv.generated.monthCurrent': 'Månadsrådet är uppdaterat i dag',
  'adv.generated.previousMonthCurrent': 'Tillbakablicken är uppdaterad i dag',
  'adv.generated.noDataChanges': 'Inga nya data',
  'adv.generated.monthCooldown': 'Uppdateras varje vecka',
  'adv.generated.todayAlreadyCurrent': 'Dagens råd är redan tillgängligt. Du får ett nytt dagsråd tidigast nästa dag.',
  'adv.generated.monthAlreadyCurrent': 'Månadsrådet är uppdaterat i dag. Det kan uppdateras igen i morgon om bokföringsunderlaget ändras.',
  'adv.generated.previousMonthAlreadyCurrent': 'Tillbakablicken är uppdaterad i dag. Den kan uppdateras igen i morgon om nya data bokförs i perioden.',
  'adv.generated.noDataChangesInfo': 'Inga nya bokföringsdata sedan föregående råd. Inga AI-anrop användes.',
  'adv.generated.monthCooldownInfo': 'Månadsrådet kan uppdateras en gång per vecka när bokföringsunderlaget har ändrats.',
  'adv.generated.previousKept': 'Det föregående rådet ligger kvar.',
  'adv.generated.type.booked': 'Bokfört faktum',
  'adv.generated.type.calculated': 'Beräknat',
  'adv.generated.type.scenario': 'Scenario',
  'adv.generated.type.opportunity': 'Möjlighet',
  'adv.generated.type.control': 'Kontrollpunkt',
  'adv.generated.confidence.high': 'Bra underlag',
  'adv.generated.confidence.medium': 'Medelgott underlag',
  'adv.generated.confidence.low': 'Tunt underlag',
  'adv.health.title': 'Ekonomisk hälsopoäng',
  'adv.health.sub': 'Samlad bedömning av företagets finansiella tillstånd',
  'adv.health.help': 'Samlad poäng visas bara när alla fyra nyckeltal kan beräknas. Okända värden ger inga poäng. Se dataunderlaget för vad som saknas.',
  'adv.health.badge.good': 'Frisk',
  'adv.health.badge.stable': 'Stabil',
  'adv.health.badge.weak': 'Svag',
  'adv.health.badge.none': 'Inte tillräckligt med data',
  'adv.health.word.good': 'God ekonomisk hälsa',
  'adv.health.word.stable': 'Stabil ekonomi',
  'adv.health.word.weak': 'Behöver följas upp',
  'adv.health.word.none': 'Preliminär bedömning',
  'adv.health.emptyTitle': 'Inte tillräckligt med data för hälsopoäng',
  'adv.health.emptyText': 'Bokför försäljning, inköp och öppna poster för att aktivera analysen.',
  'adv.health.summaryFallback': 'SuperPlumma bedömer likviditet, tillväxt, lönsamhet och stabilitet utifrån din bokföring.',
  'vat.wordMva': 'moms',
  'vat.wordMoms': 'moms',
  'vat.exemptMva': 'Utanför MVA-loven',
  'vat.exemptMoms': 'Utanför moms',
  'vat.rateLabel': '{{rate}} % {{word}}',
  'vat.zeroRated': '0 % {{suffix}}',
  'vat.zeroRatedSuffixMva': 'undantaget',
  'vat.zeroRatedSuffixMoms': 'momsfritt',
  'vat.salesReverseCharge51': '51 - Omvänd skattskyldighet vid försäljning',
  'vat.export52': '52 - Export/utförsel',
  'adv.health.category.likviditet': 'Likviditet',
  'adv.health.category.vekst': 'Tillväxt',
  'adv.health.category.lonnsomhet': 'Lönsamhet',
  'adv.health.category.stabilitet': 'Stabilitet',
  'adv.health.note.noOpenPayables': 'Inga öppna leverantörsskulder registrerade',
  'adv.health.note.noDebt': 'Inga skulder',
  'adv.health.note.unknown': 'Okänt',
  'adv.health.note.receivablesVsPayables': 'Kundfordringar mätt mot öppna leverantörsskulder',
  'adv.health.note.zeroPrevYearRevenue': 'Fjolårets omsättning är 0; procentuell tillväxt kan inte beräknas',
  'adv.health.note.needsPrevYear': 'Behöver siffror från i fjol för jämförelse',
  'adv.health.note.revenueChangeVsPrevYear': 'Omsättningsförändring jämfört med samma år i fjol',
  'adv.health.note.marginFromReport': 'Resultatmarginal från resultatrapporten',
  'adv.health.note.noBookedRevenue': 'Ingen bokförd omsättning under valt år',
  'adv.health.note.largestCustomerShare': 'Andel av försäljningen från största kund',
  'adv.health.note.needsInvoicesPerCustomer': 'Behöver fakturaförsäljning per kund',
  'adv.help.healthCard': 'Hälsopoängen är en enkel totalsumma från 0 till 100. Den tittar på flera saker samtidigt, som pengar på kontot, intäkter, kostnader och risk. Det är en fingervisning, inte en dom.',
  'adv.help.liquidity': 'Detta belopp är öppna kundfordringar minus öppna leverantörsskulder. Det visar inte hur mycket pengar som finns på bankkontot.',
  'adv.help.expectedBalance': 'Beräknat plansaldo vid periodens slut. Siffrorna bygger inte på avstämt banksaldo eller säkra betalningsdatum.',
  'adv.help.expectedIn': 'Bokförda intäkter i det visade fönstret, inte bekräftade inbetalningar.',
  'adv.help.expectedOut': 'Bokförda kostnader i det visade fönstret, inte bekräftade utbetalningar.',
  'adv.help.cashBalance': 'Saldo är de pengar som finns tillgängliga just nu i beräkningen.',
  'adv.help.bookedIn': 'Bokfört in är intäkter eller inbetalningar som redan finns i bokföringen för perioden.',
  'adv.help.bookedOut': 'Bokfört ut är kostnader eller utbetalningar som redan finns i bokföringen för perioden.',
  'adv.help.endBalance': 'Slutsaldo är dagens saldo plus pengar in, minus pengar ut. Det visar var kassan hamnar i den här beräkningen.',
  'adv.help.buffer': 'Likviditetsbuffert är en önskad säkerhetsgräns. Det är inte ett eget konto, utan ett belopp som Plumme använder för att varna när kassan blir för låg.',
  'adv.help.bufferMinimum': 'Miniminivå är Plummes lägsta rekommenderade buffert. Den hindrar att rekommendationen blir alldeles för låg när företaget har lite historik.',
  'adv.help.monthlyCosts': 'En månads kostnader betyder ungefär vad företaget vanligtvis gör av med på en månad. Det hjälper dig att klara en trög månad.',
  'adv.help.taxReserve': 'Skattereserv är pengar du bör avsätta till skatt, så att skatteräkningen inte kommer som en överraskning.',
  'adv.help.vatDue': 'Kommande moms är mervärdesskatt som ser ut att behöva betalas vid nästa momsdeadline.',
});
